import React, { useContext, useEffect, useRef, useState } from 'react'

import useResize from 'hooks/useResize'

import { ProjectContext } from 'pages/Editor/contexts/projectContext'

import CoverPreview from '../../../components/Modals/components/CoverPreview/CoverPreview'

import SpinButton from './components/SpinButton/SpinButton'
import WinArrow from './components/WinArrow/WinArrow'
import Sections from './components/Sections/Sections'
import Section from './components/Section/Section'
import SectionContent from './components/SectionContent/SectionContent'

import useWheelParams from './hooks/useWheelParams'

import { getSectionColors } from './utils'

import styles from './Preview.module.scss'

const Preview = ({
    colorTheme,
    colorScheme,
    fontFamily,
    sections,
    sectionType,
    spinImageUrl,
    isShowCover,
    coverHeader,
    coverButtonText,
    isModal = false,
    isRewardable = false,
}) => {
    const containerRef = useRef()
    const [containerWidth] = useResize(containerRef)

    const { project } = useContext(ProjectContext)

    const [actualSections, setActualSections] = useState({ isDuplicate: false, list: [] })
    useEffect(() => {
        if (isRewardable) {
            const rewardsList = project.projectStructureJson.app?.rewards?.list
            if (!!rewardsList) {
                const newSections = rewardsList.map(reward => ({
                    id: reward.id,
                    text: reward.name,
                    imageUrl: reward.previewImageUrl,
                    resultHeader: reward.header,
                    resultImageUrl: reward.imageUrl,
                    resultButtonLink: reward.buttonUrl,
                    resultButtonText: reward.buttonText,
                    resultDescription: reward.description,
                    probabilityOfWinning: reward.weight,
                    resultImageDisclaimer: reward.imageDisclaimer,
                }))
                if (newSections.length === 1) {
                    setActualSections({ isDuplicate: true, list: [...newSections, ...newSections] })
                } else {
                    setActualSections({ isDuplicate: false, list: newSections })
                }
            }
        } else {
            if (sections.length === 1) setActualSections({ isDuplicate: true, list: [...sections, ...sections] })
            else setActualSections({ isDuplicate: false, list: sections })
        }
    }, [isRewardable, sections, project.projectStructureJson.app?.rewards])

    const {
        wheelDiameter,
        wheelInnerDiameter,
        borderWidth,
        pinSize,
        arrowHeight,
        arrowTop,
        contentWidth,
        contentHeight,
        contentBottomGap,
    } = useWheelParams(containerWidth, sectionType, 360 / actualSections.list.length, actualSections.list.length)

    return (
        <div className={styles.preview}>
            {isShowCover && (
                <CoverPreview
                    isModal={isModal}
                    colorTheme={colorTheme}
                    headerText={coverHeader}
                    buttonText={coverButtonText}
                />
            )}
            <div className={styles.wheelSpin} ref={containerRef}>
                <div className={styles.wheelSpinContainer} style={{ width: wheelDiameter }}>
                    <SpinButton imageUrl={spinImageUrl} size={pinSize} />
                    <WinArrow colorTheme={colorTheme} size={arrowHeight} top={arrowTop} />
                    <Sections borderWidth={borderWidth} wheelSize={wheelDiameter}>
                        {actualSections.list.map((section, index) => {
                            const { backgroundColor, textColor } = getSectionColors(
                                colorTheme,
                                actualSections.list.length,
                                index,
                                colorScheme,
                            )

                            return (
                                <Section
                                    key={index}
                                    rotateDeg={(360 / actualSections.list.length) * index}
                                    sectionsCount={actualSections.list.length}
                                    backgroundColor={backgroundColor}
                                    wheelInnerDiameter={wheelInnerDiameter}
                                    isHidden={actualSections.isDuplicate && index !== 0}
                                    isMaster={actualSections.isDuplicate && index === 0}
                                >
                                    <SectionContent
                                        width={contentWidth}
                                        bottom={pinSize / 2 + contentBottomGap}
                                        height={contentHeight}
                                        section={section}
                                        sectionType={sectionType}
                                        textColor={textColor}
                                        fontFamily={fontFamily}
                                    />
                                </Section>
                            )
                        })}
                    </Sections>
                </div>
            </div>
        </div>
    )
}

export default Preview
